import PaymentReturn from 'components/Cart/Payment/PaymentReturn';
import { Customer } from 'components/User/Customer';
import useAppSelector from 'hooks/useAppSelector';
import { Attestations } from 'pages/Attestations';
import Cart from 'pages/Cart';
import Home from 'pages/Home';
import { Orders } from 'pages/Orders';
import Product from 'pages/Product';
import Products from 'pages/Products';
import { SearchResult } from 'pages/SearchResult';
import { Users } from 'pages/Users';
import { Route, Routes } from 'react-router-dom';
import { selectUserInfo } from 'store/reducers/shopSlice';

function ShopRoutes() {
    const isAuthenticated = useAppSelector(selectUserInfo)?.isAuthenticated;
    return (
        <Routes>
            <Route path="/">
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/cart/payment-return" element={<PaymentReturn />} />
                <Route path="/products/:category" element={<Products />} />
                <Route path="/product/:category?/:productNumber" element={<Product />} />
                <Route path="/search" element={<SearchResult />} />
                {isAuthenticated && (
                    <>
                        <Route path="/customer" element={<Customer />} />
                        <Route path="/attestations" element={<Attestations />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/users" element={<Users />} />
                    </>
                )}
                <Route path="/404" element={<></>} />
                <Route path="/*" element={<Products />} />
            </Route>
        </Routes>
    );
}

export default ShopRoutes;
